module.exports = __webpack_public_path__ + "img/logo.4eb0bdad.svg";